// CC: taken from powershell-integration.component.ts, simplified for onboarding wizard
import * as util from 'util';
import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {GeneralService} from '../../../services/generalService';
import {RouteService} from '../../../services/routeService';
import {NotificationService} from '../../../services/notificationService';
import {DICTIONARY} from '../../../dictionary';

@Component({
	selector: 'onboarding-powershell-integration-component',
	templateUrl: './onboarding-powershell-integration.component.html',
})
export class OnboardingPowershellIntegrationComponent implements OnInit {
	@Input() pageOrigin: string; // 'inbound' or 'outbound'
	@Output() connectionChanged = new EventEmitter<void>();

	dic = DICTIONARY;
	planInfo;
	connected = false;
	connectInProcess = false;
	rulesInProcess = false;
	protectionInProcess = false;

	// CC: taken from powershell-integration.component.ts -> exchangePowershellCommands
	exchangePowershellCommands = {
		login: 'login',
		rules: 'rules',
		protection: 'protection',
	};

	exchangePowershellPopup: any = {};

	constructor(public gs: GeneralService,
				private rs: RouteService,
				private ns: NotificationService) {
	}

	ngOnInit() {
		this.getIntegrations();
	}

	getIntegrations = () => {
		this.rs.getIntegrations().then((planInfo) => {
			this.planInfo = planInfo;
			this.connected = !!(this.planInfo?.powershell?.enabled &&
				(this.planInfo?.powershell?.refresh_token || this.planInfo?.exchange_server?.exoadmin_enabled));
		});
	}

	// CC: taken from powershell-integration.component.ts -> connectToPowershell (connect only)
	connectToPowershell = () => {
		this.exchangePowershellPopup[this.exchangePowershellCommands.login] = {show: true};
	}

	// CC: taken from powershell-integration.component.ts -> closeExchangePowershellPopup
	closeExchangePowershellPopup = (type, success, disconnected) => {
		if (type === this.exchangePowershellCommands.login && success) {
			if (!this.planInfo.powershell.enabled) {
				this.planInfo.powershell = {enabled: true, refresh_token: true};
			}
			else {
				this.planInfo.powershell.refresh_token = true;
			}
			this.connected = true;
			this.connectionChanged.emit();
		}

		if (disconnected) {
			this.planInfo.powershell.refresh_token = false;
			this.connected = false;
			this.connectionChanged.emit();
		}

		this.exchangePowershellPopup[type] = null;
	}

	// CC: taken from powershell-integration.component.ts -> openExchangePowershellPopup (rules)
	openSetRules = () => {
		const source = this.pageOrigin;

		if (source === 'inbound' && !this.planInfo.inbound_relay?.enabled) {
			const url = this.gs.buildInternalUrl(`/${DICTIONARY.CONSTANTS.appStates.adminInbound}/${DICTIONARY.CONSTANTS.adminPages.inbound.plan}/${DICTIONARY.CONSTANTS.inboundPlanSettingsPageTabs.emailFlowIntegration}`);
			const message = util.format(DICTIONARY.ERRORS.wizardNoRelay,
				'Inbound',
				`<a target="_self" href="${url}"><b><i>Mail Flow Integration page</i></b></a>`);
			this.ns.showErrorMessage(message);
			return;
		}
		else if (source === 'outbound' && !this.planInfo.outbound_relay?.enabled) {
			const url = this.gs.buildInternalUrl(`/${DICTIONARY.CONSTANTS.appStates.adminOutbound}/${DICTIONARY.CONSTANTS.adminPages.outbound.sharedPlan}/${DICTIONARY.CONSTANTS.outboundPlanSettingsPageTabs.emailFlowIntegration}`);
			const message = util.format(DICTIONARY.ERRORS.wizardNoRelay,
				'Outbound',
				`<a target="_self" href="${url}"><b><i>Mail Flow Integration page</i></b></a>`);
			this.ns.showErrorMessage(message);
			return;
		}

		this.exchangePowershellPopup[this.exchangePowershellCommands.rules] = {show: true, source};

		let verifiedDomains = [];
		if (this.planInfo.exchange_server?.enabled && this.planInfo.exchange_server?.verified_domains?.length) {
			verifiedDomains = this.planInfo.exchange_server.verified_domains;
		}
		else {
			verifiedDomains = this.planInfo.domains?.filter(domain => domain.verified).map(domain => domain.domain) || [];
		}
		this.exchangePowershellPopup[this.exchangePowershellCommands.rules].domains = verifiedDomains;
	}

	// CC: taken from powershell-integration.component.ts -> openExchangePowershellPopup (protection)
	openDisableProtection = () => {
		this.exchangePowershellPopup[this.exchangePowershellCommands.protection] = {show: true};
	}
}
